import React, {useContext} from "react";
import HelpComponent from "components/HelpComponent";
import FormTranslationContext from "context/FormTranslationContext";
import DatePicker from "components/DatePicker";

function NoticeDateInput
({
     id,
     formikProps,
     required
 }) {
    const {formTr, formTip} = useContext(FormTranslationContext)
    const tip = formTip(id);


    const input = <DatePicker
        formikProps={formikProps}
        id={id}
        label={formTr(id)}
        required={required}
        skipCheckTouched
    />

    if (tip)
        return <HelpComponent text={tip}>
            {input}
        </HelpComponent>
    return input;


}

export default NoticeDateInput;